import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UserDetailsDto } from '@shared/service-proxies/service-proxies';
import { OverlayPanel } from 'primeng/overlaypanel';


@Component({
    selector: "single-user-image",
    templateUrl: "./single-user-image.component.html",
    styleUrls: ["./single-user-image.component.scss"],
})
export class SingleUserImageComponent implements OnInit {
    constructor() {}
    @Input() user: UserDetailsDto;
    @Input() size: string;

    ngOnInit(): void {}

}
